import { useTranslation } from "react-i18next";
import { Map } from "leaflet";
import { Portal } from "@mui/material";

import { useStudyArea } from "hooks/studyAreaHooks";
import {
  useMeasureConfigs,
  useMeasureConfigsByMeasureType,
} from "hooks/measureConfigHooks";

import { RenderStudyArea } from "components/map/layers/RenderStudyArea";
import { MeasuresFooter } from "components/footer/MeasuresFooter";
import { RenderMeasureConfigs } from "components/measures/addMeasurePage/RenderMeasureConfigs";
import { MeasuresOverview } from "../measures/measuresPage/MeasuresOverview";
import { JoyrideActivator } from "components/joyride/JoyrideActivator";

interface Props {
  mapRef: Map;
  uuid: string;
  footerRef: HTMLDivElement;
}
export function MeasuresPageDrawerContent(props: Props) {
  const { mapRef, uuid, footerRef } = props;
  const { t } = useTranslation();

  const { data: measureConfigs } = useMeasureConfigs(uuid);
  const { data: studyArea } = useStudyArea(uuid);

  const isReadOnly = !!studyArea?.readOnly;

  const { hardenedSurfaceConfigs, adaptiveConfigs } =
    useMeasureConfigsByMeasureType(measureConfigs || []);


  return (
    <>
      <JoyrideActivator />
      <MeasuresOverview
        mapRef={mapRef}
        measureConfigs={hardenedSurfaceConfigs}
        label={t("label.pavement")}
        noResultsFound={t("label.noPavementElementsPresentYet")}
        buttonTitle={t("label.addNewPagin")}
        navSuffix={"hardened-surface"}
        isReadOnly={isReadOnly}
        uuid={uuid}
      />

      <MeasuresOverview
        mapRef={mapRef}
        measureConfigs={adaptiveConfigs}
        label={t("label.measures")}
        noResultsFound={t("label.noAdaptiveMeasuresPresentYet")}
        buttonTitle={t("label.addNewMeasure")}
        navSuffix={"adaptive-measure"}
        isReadOnly={isReadOnly}
        uuid={uuid}
      />

      <RenderMeasureConfigs
        mapRef={mapRef}
        measureConfigs={measureConfigs || []}
      />
      <Portal container={footerRef}>
        <MeasuresFooter uuid={uuid} measureConfigs={measureConfigs || []} />
      </Portal>
      {studyArea && (
        <RenderStudyArea
          mapRef={mapRef}
          studyAreaGeo={studyArea.geometry_4326}
        />
      )}
    </>
  );
}
